import { useState } from 'react';
import { CncEquipment } from '../../../../shared/types/mtlinkiTypes.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { CncSignalsDialog } from './cncSignalsDialog.tsx';
import { CncSignalsTable } from './cncSignalsTable.tsx';

interface DialogState {
    equipment: CncEquipment,
}


export function CncSignals() {
    const [dialogState, setDialogState] = useState<DialogState | null>(null);


    const equipmentsQuery = trpc.equipments.getAllCncExt.useQuery(undefined, {
        select: (cncEquipments) => [...cncEquipments].sort((a, b) => a.displayName.localeCompare(b.displayName))
    });
    const equipments = equipmentsQuery.data;


    return (<>
        <div>
            <h2>Equipment signals</h2>
            {equipmentsQuery.isLoading && <div>Loading...</div>}
            {equipmentsQuery.error && <div>Error retrieving data</div>}
            {equipments && <CncSignalsTable
                equipments={equipments}
                onEditClick={(equipment) => setDialogState({ equipment })}
            />}
        </div>

        {dialogState && <CncSignalsDialog
            equipment={dialogState.equipment}
            onEquipmentUpdated={() => equipmentsQuery.refetch()}
            onClose={() => { setDialogState(null) }}
        />}
    </>)
}
